
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bluetooth-low-energy",
      function () {
        return require("private-next-pages/bluetooth-low-energy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bluetooth-low-energy"])
      });
    }
  